import * as TYPES from './test-results-actiontypes';

export const testResultsLoadedSuccess = (testResults, userPreferenceDateFilter) => (
  {
    type: TYPES.TEST_RESULTS_LOADED_SUCCESS,
    testResults,
    userPreferenceDateFilter,
  }
);

export const newTestResultsCountLoadSuccess = (notReviewedTestResultsCount) => (
  {
    type: TYPES.NEW_TEST_RESULTS_COUNT_LOADED,
    notReviewedTestResultsCount,
  }
);

export const selectedTestResultChanged = (selectedTestResultIndex) => (
  {
    type: TYPES.SELECTED_TEST_RESULT_CHANGED,
    selectedTestResultIndex,
  }
);

export const testResultDetailsLoadSuccess = (testResult) => (
  {
    type: TYPES.TEST_RESULT_DETAILS_LOAD_SUCCESS,
    testResult,
  }
);

export const testResultGroupSorted = (testGroupId, field, sortDirection) => (
  {
    type: TYPES.TEST_RESULT_GROUP_SORTED,
    testResultGroupId: testGroupId,
    dataField: field,
    direction: sortDirection,
  }
);

export const filterOptionsChanged = (filter) => ({
  type: TYPES.TESTRESULTS_FILTER_OPTIONS_CHANGED,
  filter,
});

export const toggleFilterPanel = (showFilterPanel) => ({
  type: TYPES.TESTRESULTS_TOGGLE_FILTER_PANEL,
  showFilterPanel,
});
